/**
 * SMS signup (sections/sms-signup.liquid).
 *
 * Sends the Postscript keyword form in the background so the visitor stays on
 * the page, then swaps the form for the thank-you message. Postscript's
 * endpoint sends no CORS headers, so the response is opaque (`no-cors`): a
 * request that reaches Postscript counts as subscribed; only a network failure
 * shows the error. Without JavaScript the form posts normally.
 */

if (!customElements.get('sms-signup')) {
  customElements.define(
    'sms-signup',
    class SmsSignup extends HTMLElement {
      abortController = null;

      connectedCallback() {
        this.form = this.querySelector('.sms-signup__form');
        if (!this.form) return;

        this.abortController = new AbortController();
        this.form.addEventListener('submit', (event) => this.onSubmit(event), { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      /** @param {SubmitEvent} event */
      async onSubmit(event) {
        event.preventDefault();

        const button = this.form.querySelector('[type="submit"]');
        const success = this.form.querySelector('[data-sms-signup-success]');
        const error = this.form.querySelector('[data-sms-signup-error]');
        button.disabled = true;
        error.hidden = true;

        try {
          await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            mode: 'no-cors',
            signal: this.abortController.signal,
          });

          for (const field of this.form.querySelectorAll('input:not([type="hidden"]), .sms-signup__disclaimer, [type="submit"]')) {
            field.hidden = true;
          }
          success.hidden = false;
        } catch (fetchError) {
          if (fetchError.name === 'AbortError') return;
          error.hidden = false;
          button.disabled = false;
        }
      }
    }
  );
}
